// product-series.js — the series' key (sections/product-series): every version of the series into the cart in
// one request (DRAYKI.cart.addMany: the ones already in the cart are left out; /cart/add.js, so the pixel's
// AddToCart fires), then the cart opens. Without the cart's API, the link (/cart/v1:1,v2:1) goes to checkout.
(() => {
  const W = window, doc = document;
  doc.addEventListener('click', (e) => {
    const a = e.target && e.target.closest ? e.target.closest('[data-series-go]') : null;
    if (!a || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
    const api = W.DRAYKI && W.DRAYKI.cart;
    if (!api || typeof api.addMany !== 'function') return;
    e.preventDefault();
    if (a.getAttribute('aria-busy') === 'true') return;
    a.setAttribute('aria-busy', 'true');
    const ids = (a.getAttribute('data-series-go') || '').split(',').filter(Boolean);
    api.addMany(ids, { open: true, from: a }).then(() => a.removeAttribute('aria-busy'), () => { location.href = a.href; });
  });
  W.addEventListener('pageshow', () => { for (const a of doc.querySelectorAll('[data-series-go][aria-busy]')) a.removeAttribute('aria-busy'); });
})();
